import { atom } from 'recoil';

export const snackbarAtom = atom({
  key: 'snackbarState', // unique ID (with respect to other atoms/selectors)
  default: {
    // default value (aka initial value)
    open: false,
    message: '',
    severity: 'error'
  }
});
